export default __webpack_public_path__ + "static/media/searchIcon.0d1e323b.svg";